// import reportWebVitals from './reportWebVitals';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import { config } from './config/env';

import './index.css';

if (config.monitoring.instana) {
  ineum('key', config.monitoring.instana);
  ineum('trackSessions');
}

const root = ReactDOM.createRoot(
  (document.getElementById('root') as HTMLElement) || document.createElement('div')
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
